export const isOpen = (state, name) => !!state.modal[name];
